<template>
  <div>
    <b-row class="mb-2">
      <b-col
cols="12"
md="4"
lg="3"
>
        <label>Date Range</label>
        <date-range-picker
          v-model="pickerDates"
          :config="config"
          :locale-data="locale"
          @update="dateChange"
        />
      </b-col>
    </b-row>

    <b-overlay
:show="isLoading"
rounded="sm"
>
      <b-row class="match-height">
        <!-- Stat Cards -->
        <b-col
sm="6"
xl="3"
>
          <b-card class="mb-2 mb-xl-0">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar
size="48"
variant="light-primary"
>
                  <feather-icon
icon="DollarSignIcon"
size="24"
/>
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
Rp{{ Number(totalIDR).toLocaleString() }}
</h4>
                <b-card-text class="font-small-3 mb-0">
Total Invoice IDR
</b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col
sm="6"
xl="3"
>
          <b-card class="mb-2 mb-xl-0">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar
size="48"
variant="light-success"
>
                  <feather-icon
icon="DollarSignIcon"
size="24"
/>
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
${{ Number(totalUSD).toLocaleString() }}
</h4>
                <b-card-text class="font-small-3 mb-0">
Total Invoice USD
</b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col
sm="6"
xl="3"
>
          <b-card class="mb-2 mb-xl-0">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar
size="48"
variant="light-danger"
>
                  <feather-icon
icon="MinusIcon"
size="24"
/>
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
{{ kFormatter(totalUnconfirmed) }}
</h4>
                <b-card-text class="font-small-3 mb-0">
Total Unconfirmed
</b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col
sm="6"
xl="3"
>
          <b-card class="mb-2 mb-xl-0">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar
size="48"
variant="light-success"
>
                  <feather-icon
icon="CheckIcon"
size="24"
/>
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
{{ kFormatter(totalConfirmed) }}
</h4>
                <b-card-text class="font-small-3 mb-0">
Total Confirmed
</b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>

        <!-- Charts -->
        <b-col md="6">
          <b-card no-body>
            <b-card-header>
              <b-card-title>Invoice IDR</b-card-title>
            </b-card-header>
            <b-card-body>
              <chartjs-component-bar-chart
                v-if="totalIDR > 0"
                :height="400"
                :data="dataBarIDR"
                :options="chartjsData.latestBarChart.options"
              />
              <p
v-else
class="text-muted text-center mb-0 py-5"
>
No IDR data for this period
</p>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card no-body>
            <b-card-header>
              <b-card-title>Invoice USD</b-card-title>
            </b-card-header>
            <b-card-body>
              <chartjs-component-bar-chart
                v-if="totalUSD > 0"
                :height="400"
                :data="dataBarUSD"
                :options="chartjsData.latestBarChart.options"
              />
              <p
v-else
class="text-muted text-center mb-0 py-5"
>
No USD data for this period
</p>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Tables -->
        <b-col cols="12">
          <b-card no-body>
            <b-card-header>
              <b-card-title>Invoice Income Table (IDR)</b-card-title>
            </b-card-header>
            <b-table
striped
hover
:items="itemsIdr"
:fields="fields"
show-empty
empty-text="No data for this period"
/>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card no-body>
            <b-card-header>
              <b-card-title>Invoice Income Table (USD)</b-card-title>
            </b-card-header>
            <b-table
striped
hover
:items="itemsUSD"
:fields="fields"
show-empty
empty-text="No data for this period"
/>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BCardText,
  BTable,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BOverlay,
} from 'bootstrap-vue'

import { getToken } from '@/auth/utils'
import axios from 'axios'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import { kFormatter } from '@core/utils/filter'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BTable,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BOverlay,
    DateRangePicker,
    ChartjsComponentBarChart,
  },
  data() {
    const defaultStartDate = moment().subtract(30, 'days').toDate()
    const defaultEndDate = new Date()
    const routeStartDate = this.$route.params.startDate ? new Date(this.$route.params.startDate) : defaultStartDate
    const routeEndDate = this.$route.params.endDate ? new Date(this.$route.params.endDate) : defaultEndDate

    return {
      chartjsData,
      isLoading: false,
      fields: ['branch', 'kode_unit_kerja', 'currency', 'nominal'],
      itemsIdr: [],
      itemsUSD: [],
      totalIDR: 0,
      totalUSD: 0,
      totalConfirmed: 0,
      totalUnconfirmed: 0,
      labelsIDR: [],
      labelsUSD: [],
      dataIDR: [],
      dataUSD: [],
      dataBarIDR: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: '#28dac6',
            borderColor: 'transparent',
          },
        ],
      },
      dataBarUSD: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: '#ff4961',
            borderColor: 'transparent',
          },
        ],
      },
      config: {
        wrap: true,
        dateFormat: 'Y-m-d',
      },
      pickerDates: {
        startDate: routeStartDate,
        endDate: routeEndDate,
      },
      locale: {
        direction: 'ltr',
        format: 'yyyy/mm/dd',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        firstDay: 1,
      },
    }
  },
  mounted() {
    this.getExecutive()
  },
  methods: {
    kFormatter,
    async getExecutive() {
      this.isLoading = true

      const dateFrom = moment(this.pickerDates.startDate).format('YYYY-MM-DD')
      const dateTo = moment(this.pickerDates.endDate).format('YYYY-MM-DD')

      const userToken = getToken()
      const headers = {
        'X-Token-Access': `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      }
      const body = {
        DateFrom: dateFrom,
        DateTo: dateTo,
      }

      try {
        const res = await axios.post('https://api.geolims.com/dashboard_service/Executive', body, { headers })

        if (res.data.Status === 1) {
          const { Payload } = res.data

          this.totalConfirmed = Payload['Invoice-Confirmed'][0].InvoiceConfirmed
          this.totalUnconfirmed = Payload['Invoice-UnConfirmed'][0].InvoiceUnConfirmed

          const itemsIdr = []
          const labelsIDR = []
          const dataIDR = []
          let totalIDR = 0
          Payload['ExternalAll-IDR'].forEach(item => {
            itemsIdr.push({
              kode_unit_kerja: item.KodeUnitKerja,
              branch: item.Kota,
              currency: 'IDR',
              nominal: Number(item['incomeReport-IDR']).toLocaleString(),
            })
            labelsIDR.push(item.Kota)
            dataIDR.push(parseInt(item['incomeReport-IDR'], 10) / 1000)
            totalIDR += parseInt(item['incomeReport-IDR'], 10)
          })

          const itemsUSD = []
          const labelsUSD = []
          const dataUSD = []
          let totalUSD = 0
          Payload['ExternalAll-USD'].forEach(item => {
            itemsUSD.push({
              kode_unit_kerja: item.KodeUnitKerja,
              branch: item.Kota,
              currency: 'USD',
              nominal: Number(item['incomeReport-USD']).toLocaleString(),
            })
            labelsUSD.push(item.Kota)
            dataUSD.push(parseInt(item['incomeReport-USD'], 10) / 1000)
            totalUSD += parseFloat(item['incomeReport-USD'])
          })

          this.itemsIdr = itemsIdr
          this.itemsUSD = itemsUSD
          this.totalIDR = totalIDR
          this.totalUSD = totalUSD
          this.dataBarIDR = {
            labels: labelsIDR,
            datasets: [{ data: dataIDR, backgroundColor: '#28dac6', borderColor: 'transparent' }],
          }
          this.dataBarUSD = {
            labels: labelsUSD,
            datasets: [{ data: dataUSD, backgroundColor: '#ff4961', borderColor: 'transparent' }],
          }
        } else {
          this.showError()
        }
      } catch (error) {
        console.log(error)
        this.showError()
      } finally {
        this.isLoading = false
      }
    },
    dateChange(val) {
      const fromDate = moment(val.startDate).format('YYYY-MM-DD')
      const toDate = moment(val.endDate).format('YYYY-MM-DD')
      this.$router.push({ name: 'apps-income-external-all-date', params: { startDate: fromDate, endDate: toDate } }).catch(() => {})
      this.getExecutive()
    },
    showError() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Notification',
          icon: 'BellIcon',
          variant: 'danger',
          text: 'Something went wrong fetching income data',
        },
      })
    },
  },
}
</script>
